import { UserNotificationAPI } from '../types/notification.types';
import { paginationService } from 'core/services/paginationService';
import { apiService } from 'core/services/apiService';

export const fetchUserNotifications = async (): Promise<UserNotificationAPI[]> => {
	const response = await paginationService.get<any>('/user_notifications');
	return response.data['hydra:member'] || response.data.member || [];
};

export const markNotificationAsRead = async (id: string): Promise<void> => {
	await apiService.post('/user_notifications/read', { id: +id }, { 'Content-Type': 'application/ld+json' } );
};

export const markNotificationsAsReadBulk = async (ids: string[]): Promise<void> => {
	await apiService.post(
		'/user_notifications/bulk-read',
		{ ids: ids.map((id) => +id) },
		{ 'Content-Type': 'application/ld+json' }
	);
};
